import { Box } from 'shared/ui/Box';

import styled from '@emotion/styled';

export const Tooltip = styled(Box)<{
  bottom?: string;
  left?: string;
  whiteSpace?: string;
}>`
  display: flex;
  align-items: center;
  justify-content: center;
  color: ${({ theme }) => theme.colors.black};
  background-color: ${({ theme }) => theme.colors.purewhite};
  position: absolute;
  bottom: ${({ bottom }) => bottom};
  left: ${({ left }) => left};
  border-bottom-right-radius: ${({ theme }) => theme.borderRadius};
  border-top-left-radius: ${({ theme }) => theme.borderRadius};
  border-top-right-radius: ${({ theme }) => theme.borderRadius};
  padding: 8px;
  z-index: 1000;
  border: ${({ theme }) => `2px solid ${theme.colors.black}`};
  white-space: ${({ whiteSpace }) => (whiteSpace ? whiteSpace : '')};
`;
